module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_Korea.3d71796e.jpg";